import {registerTemplateGraphNode} from "#template/template-node/register"
import {
    curveGeometryAttributeSetLike,
    curveGeometryAttributeSetLikeMarker,
    pointGeometryAttributeSetLike,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike, curveGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode, CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeSetLikeNode, CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProductOperatorPairParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"
import {
    GeometryProductOperatorPairNode,
    productOperatorPairParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"

export type CurveGeometryProductOperatorPointGeometryCurveGeometryInputParameters = ProductOperatorPairParameters<
    PointGeometryAttributeLikeNode,
    PointGeometryAttributeSetLikeNode,
    CurveGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<CurveGeometryProductOperatorPointGeometryCurveGeometryInputParameters> = {
    nodeClass: "CurveGeometryProductOperatorPointGeometryCurveGeometryInput",
    validation: {
        parameters: productOperatorPairParametersSchema(
            pointGeometryAttributeLike,
            pointGeometryAttributeSetLike,
            curveGeometryAttributeLike,
            curveGeometryAttributeSetLike,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryProductOperatorPointGeometryCurveGeometryInput
    extends GeometryProductOperatorPairNode<
        1,
        PointGeometryAttributeLikeNode,
        PointGeometryAttributeSetLikeNode,
        CurveGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode
    >
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 1 {
        return 1
    }
}
